(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider


            .state('supplierPanel.reserve.new', {
                parent: 'supplierPanel',
                url: '/reserve/new/{serviceItemId}/{start_date}/{end_date}/{servantId}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })

            .state('supplierPanel.new-reserve-modal', {
                parent: 'supplierPanel.calendar',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/reserve/new-reserve-modal-old.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('serviceItem');
                                $translatePartialLoader.addPart('orderBag');
                                $translatePartialLoader.addPart('orderBagServiceItem');
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('genderType');

                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    customer: null,
                                    createDate: null,
                                    status: 0,
                                    id: null,
                                    orderBagServiceItems: [{}]
                                };
                            }

                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        $state.go('supplierPanel.calendar', null, {reload: true});
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function () {
                        $state.go('supplierPanel.calendar');
                    });
                }]

            });

    }

})();
